// frontend/src/components/StatusPicker.tsx
import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

const API = API_URL.replace(/\/api$/, '');

export default function StatusPicker({ token, currentStatus, onUpdated }: any) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  async function saveChoice(choice: { mood: string; emoji: string }) {
    if (!token) return;
    try {
      setSaving(true);
      const res = await axios.post(
        API + '/api/status',
        { mood: choice.mood, emoji: choice.emoji },
        { headers: { Authorization: 'Bearer ' + token } },
      );
      const statusData = res.data?.status || res.data;
      if (statusData) onUpdated(statusData);
      setOpen(false);
    } catch (err) {
      console.error('status save error', err);
    } finally {
      setSaving(false);
    }
  }

  async function clearStatus() {
    if (!token) return;
    try {
      console.log('StatusPicker: Clearing status');
      await axios.delete(API + '/api/status', { headers: { Authorization: 'Bearer ' + token } });
      console.log('StatusPicker: Status cleared, calling onUpdated(null)');
      onUpdated(null);
      setOpen(false);
    } catch (err) {
      console.error('status clear error', err);
    }
  }
  
  const choices = [
    { emoji: '🟢', mood: 'Online' },
    { emoji: '🟡', mood: 'Away' },
    { emoji: '🔴', mood: 'Do Not Disturb' },
    { emoji: '💼', mood: 'In a meeting' },
    { emoji: '☕', mood: 'On a break' },
    { emoji: '📚', mood: 'Studying' },
    { emoji: '🏋️', mood: 'At the gym' },
    { emoji: '✈️', mood: 'Traveling' },
  ];

  return (
    <div className="status-picker relative">
      <div className="flex justify-between items-center mb-2">
        <h4 className="font-semibold text-sm text-slate-300">Status</h4>
        <button
          className="text-xs text-cyan-400 hover:text-cyan-300 hover:underline transition-colors font-medium"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Close' : (currentStatus ? 'Change' : 'Set status')}
        </button>
      </div>

      {!open && !currentStatus && (
        <p className="text-xs text-slate-400 italic">No status set</p>
      )}

      {open && (
        <div className="absolute right-0 mt-1 w-56 rounded-lg shadow-lg border bg-slate-800/95 border-slate-700 z-20">
          <div className="py-1 max-h-64 overflow-auto">
            <button
              className="w-full text-left px-3 py-2 text-sm text-slate-300 hover:bg-slate-700/70 flex items-center gap-2"
              onClick={clearStatus}
              disabled={saving}
            >
              <span className="text-base">✖️</span>
              <span>No status</span>
            </button>
            <div className="my-1 border-t border-slate-700" />
            {choices.map((c) => (
              <button
                key={c.mood}
                className="w-full text-left px-3 py-2 text-sm text-slate-200 hover:bg-slate-700/70 flex items-center gap-2 disabled:opacity-50"
                onClick={() => saveChoice(c)}
                disabled={saving}
              >
                <span className="text-base">{c.emoji}</span>
                <span>{c.mood}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
